import { Flex, VStack, Text, HStack, Image, Stack, useMediaQuery, Heading } from '@chakra-ui/react';
import checkmark from 'Assets/svg/Checkmark.svg';
import React from 'react';
import phoneLoop from 'Assets/Images/phone-loop.png';
import phoneLoopMobile from 'Assets/Images/PhoneLoopMobile.png';
import { IChildren, ILoopBusinessLocalizationDocument } from 'Types/Interface/Sanity';


interface ICustomerProps{
	shouldIgnoreParentPadding: boolean;
	loopBusinessLocalization: ILoopBusinessLocalizationDocument | null;
}

export const Problem = ({shouldIgnoreParentPadding, loopBusinessLocalization}:ICustomerProps) => {
	const [isLargerThan768] = useMediaQuery('(min-width: 984px)');
	
	return(
		<Flex  
			direction={['column-reverse', 'column-reverse', 'column-reverse', 'row']} 
			bg={['#FFFCFC','#FFFCFC']} 
			w={'100%'} 
			justifyContent={['center', 'space-between', 'space-between']}
			py={['50px','100px']}
			{...(shouldIgnoreParentPadding && { px:{ base: '30px', xl: '80px', '2xl': '192px' }})}
		>
			{ isLargerThan768 ? <Flex maxWidth={'50%'} alignItems={'flex-end'} bg={['','#F5F5F5']} justifyContent={'center'}  w={'550px'} h={'650px'}>
				<Image w={'610px'}  objectFit={'contain'} h={'548px'} src={phoneLoop} />
			</Flex> :
				<Flex alignItems={'flex-end'} justifyContent={'center'} mt={['30px','50px']}>
					<Image w={['388px', '100%', '100%']}  objectFit={'contain'}  src={phoneLoopMobile} />
				</Flex>
			}
			<VStack w={['100%', '100%', '100%', '45%']} justifyContent={'center'} spacing={['30px','40px']}  align={['flex-start','flex-start']}>
				<Stack spacing={2} >
					<Heading textTransform={'uppercase'} w={'100%'} fontSize={['30px','40px']} fontWeight={'bold'}>{loopBusinessLocalization?.problem}</Heading>
					<Text fontSize={['16px','18px']}>
						{loopBusinessLocalization?.problemSubText}
					</Text>
				</Stack>
				
				<VStack spacing={'30px'} justifyContent={'center'} align={'flex-start'}>
					{
						loopBusinessLocalization?.problemItem?.map((benefit) => {
							return(
								<HStack w={['100%', null, null, null, '430px', 'auto']} alignItems={'flex-start'} key={benefit._key}>
									<Image boxSize={'20px'} src={checkmark} />
									<Text color={'blackText.200'} fontSize={['16px','18px']}>
										{benefit.children.map((child:IChildren) =>
											child.marks.includes('strong') ? (
											<strong key={child._key}>{child.text}</strong>
											) : (
											<span key={child._key}>{child.text}</span>
											)
										)}
									</Text>
								</HStack>
							);
						})
					}
				</VStack>
				<Stack spacing={2} >
					<Heading textTransform={'uppercase'} fontSize={['30px','40px']} fontWeight={'bold'}>{loopBusinessLocalization?.solution}</Heading>
					<Text fontSize={['16px','18px']}>
						{loopBusinessLocalization?.solutionSubText}
					</Text>
				</Stack>
			</VStack>
		</Flex>
	);
};